import { getCountryIdByShortcode } from '../../utils/country';
import { getBrandsByAppId } from '../Entities/Brands/brands.reducer';
import { updateBrandList } from './brandlist.actions';
import { Action } from 'redux';
import * as Immutable from 'seamless-immutable';
import { ImmutableObject } from 'seamless-immutable';
import { isType } from 'typescript-fsa';
import { LOCATION_CHANGE } from 'react-router-redux';
import { Pagination } from '../../components/Pagination/index';
import { AppState } from '../reducers';
import { getQueryParameter } from '../../utils/url';

interface BrandList {
  brandIds: number[];
  pagination?: Pagination;
  searchQuery?: string;
  country: string;
}
export type BrandListState = BrandList & ImmutableObject<BrandList>;

const initialState = Immutable.from<BrandList>({
  brandIds: [],
  country: 'de',
});

export interface BrandResult {
  entities: {
    brand: object;
  };
  result: {
    meta: object;
    data: object;
  };
}

export default function reduce(
  state: BrandListState = initialState,
  action: Action
) {
  if (isType(action, updateBrandList)) {
    const { brandIds, pagination } = action.payload;

    return state.merge({ brandIds, pagination });
  }

  if (action.type === LOCATION_CHANGE) {
    const { search, pathname } = (action as any).payload;
    if (pathname !== '/brands') {
      return state;
    }

    return state.merge({
      pagination: {
        ...state.pagination,
        currentPage: getQueryParameter('page', search, 1),
      },
      searchQuery: getQueryParameter('filter[search]', search),
      country: getQueryParameter('country', search, state.country),
    });
  }

  return state;
}

export function getBrands(state: AppState) {
  const {
    brandList: { country },
  } = state;
  const appId = getCountryIdByShortcode(country);

  return getBrandsByAppId(state, appId);
}

export function getCountry(state: AppState) {
  const {
    brandList: { country },
  } = state;

  return country;
}

export function getPagination(state: AppState) {
  const {
    brandList: { pagination },
  } = state as any;

  return pagination;
}

export function getSearchQuery(state: AppState) {
  const {
    brandList: { searchQuery },
  } = state as any;

  return searchQuery;
}



// WEBPACK FOOTER //
// ./src/store/BrandList/brandlist.reducer.ts